import Cursor from '@/components/common/cusor';
import Lines from '@/components/common/Lines';
import ProgressScroll from '@/components/common/ProgressScroll';
import Footer from '@/components/home-main/Footer';
import Navbar from '@/components/home-main/Navbar';
import { Helmet } from 'react-helmet';
import Story from './components/Story';
import Header from '../project1/components/Header';
import TPPMProtocol from './components/TPPMProtocol';

export default function DevEncryption() {
  return (
    <>
      <Helmet>
        <title>Development & Encryption</title>
        <link rel="icon" href="/light/assets/imgs/fox.webp" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/style.css"
        />
 
        <script src="/light/assets/js/scripts.js"></script>
        <script src="/light/assets/js/smoother-script.js"></script>
      </Helmet>
      <main>
        <Cursor />
        <ProgressScroll />
        <Lines />
        <div id="smooth-wrapper">
          <Navbar />
          <div id="smooth-content">
            <main className="main-bg">
              <Header title='Development at GCAD — Powered by TPPM' bgImg='https://images.unsplash.com/photo-1617396900799-f4ec2b43c7ae?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'/>
              <TPPMProtocol />
              <Story />
            </main>
            <Footer />
          </div>
        </div>
      </main>
    </>
  );
}
